
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/how-to-measure-cylinders",
      function () {
        return require("private-next-pages/[locale]/help/how-to-measure-cylinders.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/how-to-measure-cylinders"])
      });
    }
  